import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const PaymentButton = ({ paymentButtonId }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!paymentButtonId) return undefined;

    const containerEl = containerRef.current;
    if (!containerEl) return undefined;

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/payment-button.js';
    script.async = true;
    script.setAttribute('data-payment_button_id', paymentButtonId);

    containerEl.innerHTML = '';
    containerEl.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      containerEl.innerHTML = '';
    };
  }, [paymentButtonId]);

  return (
    <form ref={containerRef} style={{ marginTop: '12px' }}>
      {/* Razorpay injects the real button here */}
    </form>
  );
};

PaymentButton.propTypes = {
  paymentButtonId: PropTypes.string.isRequired,
};

export default PaymentButton;
